// // src/components/ForgotPassword.js
// import React, { useState } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../styles/auth.css';

// const ForgotPassword = () => {
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [newPassword, setNewPassword] = useState('');

//   const sendOtp = async () => {
//     try {
//       await axios.post('/api/auth/send-email-otp', { email });
//       toast.success('OTP sent to your email.');
//       setStep(2);
//     } catch (err) {
//       toast.error(err.response?.data?.msg || 'Failed to send OTP.');
//     }
//   };

//   const verifyOtp = async () => {
//     try {
//       await axios.post('/api/auth/verify-email-otp', { email, otp });
//       toast.success('OTP verified successfully.');
//       setStep(3);
//     } catch (err) {
//       toast.error(err.response?.data?.msg || 'OTP verification failed.');
//     }
//   };

//   const resetPassword = async () => {
//     try {
//       await axios.post('/api/auth/reset-password', { email, newPassword });
//       toast.success('Password reset successful!');
//       setTimeout(() => {
//         window.location.href = '/'; // 👈 Redirect to Home Page
//       }, 2000);
//     } catch (err) {
//       toast.error(err.response?.data?.msg || 'Password reset failed.');
//     }
//   };
  

//   return (
//     <div className="auth-container">
//       <ToastContainer position="top-center" autoClose={3000} />
//       <form
//         onSubmit={(e) => {
//           e.preventDefault();
//           if (step === 1) sendOtp();
//           else if (step === 2) verifyOtp();
//           else if (step === 3) resetPassword();
//         }}
//         className="auth-form"
//       >
//         <h2 className="form-title">Forgot Password</h2>
//         {step === 1 && (
//           <>
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//             <button type="submit">Send OTP</button>
//           </>
//         )}

//         {step === 2 && (
//           <>
//             <input
//               type="text"
//               placeholder="Enter OTP"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               required
//             />
//             <button type="submit">Verify OTP</button>
//           </>
//         )}

//         {step === 3 && (
//           <>
//             <input
//               type="password"
//               placeholder="Enter new password"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//               required
//             />
//             <button type="submit">Reset Password</button>
//           </>
//         )}
//       </form>
//     </div>
//   );
// };

// export default ForgotPassword;


// src/components/ForgotPassword.js
import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/auth.css';

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const sendOtp = async () => {
    try {
      await axios.post('/api/auth/send-email-otp', { email });
      toast.success('OTP sent to your email.');
      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Failed to send OTP.');
    }
  };

  const verifyOtp = async () => {
    try {
      await axios.post('/api/auth/verify-email-otp', { email, otp });
      toast.success('OTP verified successfully.');
      setStep(3);
    } catch (err) {
      toast.error(err.response?.data?.msg || 'OTP verification failed.');
    }
  };

  const resetPassword = async () => {
    try {
      const response = await axios.post('/api/auth/reset-password', {
        email,
        newPassword,
      });

      toast.success('Password reset successful!');

      // ✅ Auto login: store token and redirect
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);

        if (response.data.userType) {
          localStorage.setItem('userType', response.data.userType);
        }

        setTimeout(() => {
          window.location.href = '/'; // Redirect to a protected page
        }, 2000);
      } else {
        // Fallback: redirect to login if no token returned
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Password reset failed.');
    }
  };

  return (
    <div className="auth-container">
      <ToastContainer position="top-center" autoClose={3000} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (step === 1) sendOtp();
          else if (step === 2) verifyOtp();
          else if (step === 3) resetPassword();
        }}
        className="auth-form"
      >
        <h2 className="form-title">Forgot Password</h2>

        {step === 1 && (
          <>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Send OTP</button>
          </>
        )}

        {step === 2 && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button type="submit">Verify OTP</button>
          </>
        )}

        {step === 3 && (
          <>
            <input
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <button type="submit">Reset Password</button>
          </>
        )}
      </form>
    </div>
  );
};

export default ForgotPassword;
